import { __assign } from "tslib";
import * as React from 'react';
import { renderAndMountComponent } from '@wix/answers-lib';
import { ConfirmModal } from './confirm-modal.comp';
import { getBaseReactDriver } from '../../common/base-driver';
// tslint:disable-next-line:max-line-length
export var createLegacyConfirmModalDriver = function (elemOrLegacyBaseDriver) {
    var base = getBaseReactDriver(elemOrLegacyBaseDriver);
    return {
        getText: function () { return base.find('.title').getText(); },
        confirm: function () { return base.find('.confirm').click(); },
        cancel: function () {
            base.find('.cancel').click();
        },
        isConfirmDisabled: function () { return base.find('.confirm').hasClass('disabled'); },
        toggleCheckbox: function () { return base.find('.checkbox input').click(); },
        base: base
    };
};
export var renderConfirmModalAndReturnDriver = function (props) {
    var elem = renderAndMountComponent(React.createElement(ConfirmModal, __assign({}, props)));
    return createLegacyConfirmModalDriver(elem);
};
//# sourceMappingURL=confirm-modal.driver.js.map